import React, { FC } from 'react';
import { TableRow, TableCell, Grid } from '@material-ui/core';
import NumberFormat from 'components/NumberFormat';
import Skeleton from '@material-ui/lab/Skeleton';
import { InfoOutlined } from '@material-ui/icons';
import { YELLOW_MOBILE } from 'constants/colors';

interface Props {
  item: PurchaseInvoiceItemModel;
  isLoading: boolean;
  handleOpenHistory: () => void;
}

const BodyRow: FC<Props> = props => {
  const { item, isLoading, handleOpenHistory } = props;

  return (
    <TableRow>
      <TableCell>{isLoading ? <Skeleton variant='text' width='100%' /> : item.Product ? item.Product.productName : '-'}</TableCell>
      <TableCell align='right'>
        {isLoading ? (
          <Skeleton variant='text' width='100%' />
        ) : (
          <>
            <NumberFormat value={item.price} prefix={'Rp'} thousandSeparator={true} displayType='text' />
          </>
        )}
      </TableCell>
      <TableCell align='center'>{isLoading ? <Skeleton variant='text' width='100%' /> : item.totalItem + ' ' + item.typeUnit}</TableCell>
      <TableCell align='right'>
        {isLoading ? (
          <Skeleton variant='text' width='100%' />
        ) : (
          <NumberFormat value={item.discount} prefix={'Rp'} thousandSeparator={true} displayType='text' />
        )}
      </TableCell>
      <TableCell align='right'>
        {isLoading ? (
          <Skeleton variant='text' width='100%' />
        ) : (
          <NumberFormat value={item.totalPrice} prefix={'Rp'} thousandSeparator={true} displayType='text' />
        )}
      </TableCell>

      <TableCell align='right'>
        {isLoading ? (
          <Skeleton variant='text' width='100%' />
        ) : (
          <NumberFormat value={item.unitNetPrice} prefix={'Rp'} thousandSeparator={true} displayType='text' />
        )}
      </TableCell>
    </TableRow>
  );
};

export default BodyRow;
